import {
  ShieldCheck,
  Flame,
  AlertTriangle,
  FileBadge,
  Wrench,
  Compass,
  Award,
  Briefcase,
  Layers,
  IndianRupee,
  Sparkles,
  HeartHandshake,
  Car,
  Factory,
  Pill,
  Zap,
  Settings,
  FlaskConical,
  Building2,
  PackageCheck,
} from "lucide-react";

export const SERVICES = [
  {
    icon: ShieldCheck,
    title: "Safety & Compliance Audits",
    desc: "Identify workplace hazards, validate statutory compliance and strengthen safety governance with documented audits.",
    slug: "safety-audits",
  },
  {
    icon: Flame,
    title: "Fire & Electrical Safety",
    desc: "Comprehensive inspection and risk evaluation across fire systems, electrical infrastructure and emergency readiness.",
    slug: "fire-electrical",
  },
  {
    icon: AlertTriangle,
    title: "Industrial Risk Assessment",
    desc: "Detailed analysis of operational risks across process, machinery, chemicals and human factors with mitigation roadmaps.",
    slug: "risk-assessment",
  },
  {
    icon: FileBadge,
    title: "Factory Licensing Support",
    desc: "End-to-end approvals, statutory documentation and compliance guidance for factories and industrial premises.",
    slug: "licensing",
  },
  {
    icon: Wrench,
    title: "Equipment Testing & Certification",
    desc: "Pressure vessels, lifting machines, power presses and critical equipment — tested, validated, certified.",
    slug: "testing-certification",
  },
  {
    icon: Compass,
    title: "Engineering Advisory",
    desc: "Technical consulting, compliance solutions and engineering review for safer plant design and operations.",
    slug: "engineering-advisory",
  },
];

export const WHY_US = [
  { icon: Award, title: "ISO Certified Company", desc: "Independently certified processes and quality systems." },
  { icon: Briefcase, title: "Industry Expertise", desc: "Decades of cross-sector industrial safety experience." },
  { icon: Layers, title: "End-to-End Support", desc: "From audit through implementation and ongoing compliance." },
  { icon: HeartHandshake, title: "Technical & Legal Guidance", desc: "Statutory frameworks and engineering best practice combined." },
  { icon: IndianRupee, title: "Transparent Pricing", desc: "Clear, scoped commercials with no hidden line items." },
  { icon: Sparkles, title: "Customized Solutions", desc: "Programs tailored to your plant, risk profile and goals." },
];

export const PROCESS = [
  { step: "01", title: "Consultation", desc: "Understand audit objectives, scope and operational context." },
  { step: "02", title: "Site Inspection", desc: "Physical assessment, walkthrough and compliance review." },
  { step: "03", title: "Risk Analysis", desc: "Identify gaps, quantify hazards and prioritize controls." },
  { step: "04", title: "Detailed Report", desc: "Findings, recommendations and corrective action plan." },
  { step: "05", title: "Ongoing Support", desc: "Continuous compliance, training and improvement guidance." },
];

export const INDUSTRIES = [
  { icon: Car, name: "Automotive" },
  { icon: Factory, name: "Manufacturing" },
  { icon: Pill, name: "Pharmaceutical" },
  { icon: Zap, name: "Energy" },
  { icon: Settings, name: "Engineering" },
  { icon: FlaskConical, name: "Chemical Plants" },
  { icon: Building2, name: "Infrastructure" },
  { icon: PackageCheck, name: "Warehousing" },
];

export const CLIENTS = [
  "Bajaj Auto",
  "Siemens",
  "JSW Energy",
  "Skoda",
  "Glenmark",
  "Endurance",
  "Perkins",
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_workplace-safety-co-1/artifacts/d83ma5vp_509399fa-3d9d-42f5-a2a7-fb576d743137.jpg";

export const HERO_BG =
  "https://images.unsplash.com/photo-1777915627530-fc3decb749cf?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export const ABOUT_IMG =
  "https://images.unsplash.com/photo-1730584474428-83f3cfc20a73?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const CONTACT = {
  phone: "9175025196",
  phoneIntl: "919175025196",
  email: "infomail.insafe@gmail.com",
  address:
    "Shop No. G-24, Anand Plaza, Hotel Amarpreet Signal, Jalna Road, Chhatrapati Sambhajinagar, Maharashtra, India — 431001",
  addressShort: "Chhatrapati Sambhajinagar, Maharashtra",
};
